import {
  CalendarClock,
  Disc3,
  ListMusic,
  Radio,
  SlidersHorizontal,
} from "lucide-react";

/**
 * The whole product's navigation.
 *
 * Every destination here is one. There is no disabled entry and nothing that says
 * when something will exist: the operator's surface is the product, not a report on
 * how much of it has been built.
 */
export interface NavItem {
  to: string;
  label: string;
  icon: typeof Radio;
}

export const NAV_ITEMS: NavItem[] = [
  { to: "/feeds", label: "Feeds", icon: Radio },
  { to: "/library", label: "Library", icon: Disc3 },
  { to: "/playlists", label: "Playlists", icon: ListMusic },
  { to: "/schedules", label: "Schedules", icon: CalendarClock },
  { to: "/settings", label: "Appearance", icon: SlidersHorizontal },
];
